"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Pagination = /** @class */ (function () {
    function Pagination(json) {
        if (json === void 0) { json = {}; }
        this.offset = json.offset ? parseInt(json.offset, 10) : 0;
        this.limit = json.limit ? parseInt(json.limit, 10) : 100000;
    }
    return Pagination;
}());
exports.Pagination = Pagination;
//# sourceMappingURL=CommonModels.js.map